import { useLayoutEffect } from 'react';
import { useWorkshopMode } from '../../stores/WorkshopModeContext';

// Sentry's feedback widget (lib/sentry.js, autoInject: true) mounts itself
// directly into the DOM outside React's tree -- a host <div id="sentry-feedback">
// appended to <body> with a shadow root containing a ".widget__actor" trigger
// button -- so it cannot be hidden via a React wrapper like HideInWorkshop.
// This mirrors what the SDK's own actor.hide()/show() does internally
// (toggling aria-hidden, which its shadow CSS maps to display/visibility)
// since that actor reference isn't exposed by the public integration API.
// useLayoutEffect (not useEffect) avoids a one-frame flash of the button
// before it gets hidden on initial mount.
const FEEDBACK_HOST_ID = 'sentry-feedback';

const SentryFeedbackWorkshopGate = () => {
  const { workshopMode } = useWorkshopMode();

  useLayoutEffect(() => {
    const actor = document
      .getElementById(FEEDBACK_HOST_ID)
      ?.shadowRoot?.querySelector('.widget__actor');
    actor?.setAttribute('aria-hidden', workshopMode ? 'true' : 'false');
  }, [workshopMode]);

  return null;
};

export default SentryFeedbackWorkshopGate;
